/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useEffect, useState } from 'react';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import { getAllGroup, deleteGroup } from 'src/services/groupService';
import { Grid, IconButton, Menu, MenuItem } from '@mui/material';
import type { TableColumn } from 'react-data-table-component';
import MUIModal from '../MUIModal/MUIModal';
import AddGroupForm from './AddGroupForm';
import EditGroupForm from './EditGroupForm';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { MoreVerticalSolidRounded } from '@hugeicons-pro/core-solid-rounded';
//@ts-ignore
import { MultiplicationSignStrokeStandard } from '@hugeicons-pro/core-stroke-standard';
//@ts-ignore
import { PencilEdit02Icon } from '@hugeicons-pro/core-stroke-rounded';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import { ARE_YOU_SURE, DELETE_GROUP, DELETE_GROUP_SUCCESS_MESSAGE, GROUP_DELETE_INVALID } from 'src/constants/constant';
import OutlineButton from '../MUICustomButton/OutlineButton';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import type { RootState } from '../types/types';
import moment from 'moment';
import GradientButton from '../MUICustomButton/GradientButton';
import { checkEventPermission } from "../../common/utility/utility";
import type { TooltipProps } from '@mui/material/Tooltip';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} placement="bottom" />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ITEM_HEIGHT = 48;

interface GroupListPropType {
  "id": number;
  "clientId": number;
  "clientName": string;
  "groupName": string;
  "isDeleted": boolean;
  "createdBy": number;
  "createdByUserName": string;
  "createdOn": string;
  "modifiedBy": number;
  "modifiedOn": string;
  "modifiedByUserName": string;
  "cooldownPeriod": number | null;
  "isGroupInUse": boolean;
}

interface ApiResponse {
  status: number;
  data: {
    data: GroupListPropType[];
    result: number;
  };
}

const GroupList: React.FC = () => {

  const [groupListData, setGroupListData] = useState<GroupListPropType[]>([])
  const [groupSearchData, setGroupSearchData] = useState<GroupListPropType[]>([])
  const [openAddGroupModal, setOpenAddGroupModal] = useState<boolean>(false)
  const [openEditGroupModal, setOpenEditGroupModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)
  const [groupInfoData, setGroupnfoData] = useState<any>();
  const [showDeleteGroupModal, setDeleteGroupModal] = useState<boolean>(false);
  // const [showDeactivateWebhookModal, setDeactivateWebhookModal] = useState<boolean>(false);
  const [groupId, setGroupId] = useState<number>(0)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [anchorActionEl, setAnchorActionEl] = React.useState<any>({});
  const { user } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getgroupListData()
  }, [user])

  const getgroupListData = (): void => {
    setLoading(true)
    const ClientId = user?.clientId ?? 0;
    getAllGroup(ClientId)
      .then(
        (res: ApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              const webhookArr: GroupListPropType[] = [];
              res.data.data.map((webhook: any) => {
                webhook.Name = `${webhook.clientName}`
                webhookArr.push(webhook)
              })
              setGroupListData(webhookArr)
              setGroupSearchData(webhookArr)
            } else {
              setGroupListData([])
              setGroupSearchData([])
            }
          }
        }
      )
      .catch(
        (error: any) => console.log("Error: ", error)
      )
      .finally(() => {
        setLoading(false)
      })
  }

  const handleAddGroupClick = (): void => {
    setOpenAddGroupModal(true)
  }

  const handleCloseAddGroupModal = (): void => {
    setOpenAddGroupModal(false)
  }

  const handleEditGroupClick = (id: number): void => {
    setGroupId(id);
    setOpenEditGroupModal(true)
  }

  const handleCloseEditGroupModal = (): void => {
    setOpenEditGroupModal(false)
  }

  const handleRefreshPage = (): void => {
    getgroupListData()
    handleCloseAddGroupModal()
    handleCloseEditGroupModal()
  }

  const handleActionClick = (event: React.MouseEvent<HTMLElement>, id: number): void => {
    // anchorActionEl[id] = event.currentTarget
    setAnchorActionEl({ ...anchorActionEl, [id]: event.currentTarget });
  }

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;
    let groupDataArr = [...groupListData]
    if (value !== "") {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-optional-chain
      groupDataArr = groupDataArr && groupDataArr.filter((group: GroupListPropType) => {
        return group.groupName.toLowerCase().search(value.toLowerCase()) >= 0
      })
    }
    setGroupSearchData(groupDataArr)
  }

  const handleDeleteGroup = (id: number, groupName: string): void => {
    setGroupnfoData({ id, groupName });
    setDeleteGroupModal(true)
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [id]: null });
  }

  const handleDeleteGroupClose = (): void => {
    setDeleteGroupModal(false)
  }

  const handleDeleteGroupConfirm = (): void => {
    setIsModalSaveLoading(true)

    const { id } = groupInfoData;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"))

    const data = {
      "modifiedBy": userData.id,
      "id": id,
    }

    deleteGroup(data)
      .then(
        (res: ApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              NotificationManager.success(DELETE_GROUP_SUCCESS_MESSAGE, '', 5000);
              setDeleteGroupModal(false)
              getgroupListData()
            }
          }
        }
      )
      .catch((error: any) => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false))
  }

  // const handleactivatedeactivate = (id: number, isActive: boolean, clientName: string): void => {
  //   const newIsActive = !isActive;
  //   setGroupnfoData({ id, isActive: newIsActive, clientName });
  //   setDeactivateWebhookModal(true)
  //   setAnchorActionEl(null);
  //   setAnchorActionEl({ ...anchorActionEl, [id]: null });
  // }

  // const handleactivatedeactivateClose = ():void => {
  //     setDeactivateWebhookModal(false)
  // }

  // const handleActivateDeactivateConfirm = ():void => {

  //   setIsModalSaveLoading(true)

  //   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //   // @ts-ignore
  //   const userData = JSON.parse(localStorage.getItem("user"))
  //   const { id, isActive } = groupInfoData;

  //   const data = {
  //     "updatedBy": userData.id,
  //     "groupIdList": [
  //       {
  //         "id": id
  //       }
  //     ],
  //     "activeOrDeActive": (Boolean((groupInfoData?.isActive))) ? 1 : 0
  //   }

  //   activatedeactivate(data)
  //     .then(
  //       (res: ApiResponse) => {
  //         if(res.status === 200) {
  //           if(res.data.result === 1) {
  //             if (Boolean(isActive)) {
  //               NotificationManager.success(ACTIVATE_WEBHOOK_SUCCESS_MESSAGE, '', 5000);
  //             } else {
  //               NotificationManager.success(DEACTIVATE_WEBHOOK_SUCCESS_MESSAGE, '', 5000);
  //               // Adjust the width inline
  //               setTimeout(() => {
  //                 const notification = document.querySelector('.notification-container') as HTMLElement | null;
  //                 if (notification !== null) {
  //                   notification.style.width = '340px'; // Set your desired width
  //                 }
  //               }, 0);
  //             }
  //             setDeactivateWebhookModal(false)
  //             getgroupListData()
  //           }
  //         }
  //       }
  //     )
  //     .catch((error: any) => console.log("Error", error))
  //     .finally(() => setIsModalSaveLoading(false))
  // }

  const columns: TableColumn<GroupListPropType>[] = [
    {
      name: 'Group',
      selector: (row: GroupListPropType) => row.groupName,
      cell: (row: GroupListPropType) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            <div className="overflow-hidden" style={{ width: '100%' }}>
              <p className="text-14 text-muted">{row.groupName}</p>
            </div>
          </div>
        )
      },
      width: '40%',
      sortable: true
    },
    {
      name: 'Cooldown Period',
      selector: (row: GroupListPropType) => row.cooldownPeriod ?? 0,
      width: '25%',
      sortable: true,
      center: true,
    },
    {
      name: 'Created',
      selector: (row: GroupListPropType) => moment(row.createdOn).format('MM/DD/YYYY'),
      width: '25%',
      sortable: true
    },
    // {
    //   name: 'Status',
    //   sortable: false,
    //   width: "15%",
    //   // selector: row => row.year,
    //   cell: (row: GroupListPropType) => {
    //     return row.isActive ? <div className="badge truncate" style={{
    //       background: '#CCFFEA',
    //       padding: '10px 15px',
    //       color: '#06A864',
    //       border: '0px'
    //     }}>Active</div> : <div className="badge truncate" style={{
    //       background: '#FFF5F6',
    //       padding: '10px 15px',
    //       color: '#F13139',
    //       border: '0px'
    //     }}>Inactive</div>
    //   }
    // },
    {
      name: 'Actions',
      // selector: (row: any) => row.role,
      cell: (row: GroupListPropType) => {
        return (
          <div className='flex items-center'>
            <div onClick={() => handleEditGroupClick(row.id)} className="icon-hover-container cursor-pointer" >
              <HugeiconsIcon
                icon={PencilEdit02Icon}
                size={20}
                color="#3A3A3A"
                strokeWidth={0.2}
              />
            </div>
            {checkEventPermission("GROUPS_DELETE") &&
              <div className='flex'>
                <IconButton
                  aria-label="more"
                  id="long-button"
                  // aria-controls={open ? 'long-menu' : undefined}
                  // aria-expanded={open ? 'true' : undefined}
                  aria-haspopup="true"
                  onClick={(e) => handleActionClick(e, row.id)}
                >
                  <HugeiconsIcon
                    icon={MoreVerticalSolidRounded}
                    size={20}
                    color="#3A3A3A"
                    strokeWidth={0.2}
                  />
                </IconButton>
                <Menu
                  id={`${row.id}`}
                  className='table-action-menu'
                  MenuListProps={{
                    'aria-labelledby': 'long-button',
                  }}
                  anchorEl={anchorActionEl[row.id]}
                  open={Boolean(anchorActionEl[row.id])}
                  onClose={() => setAnchorActionEl({ ...anchorActionEl, [row.id]: null })}
                  slotProps={{ paper: {
                    style: {
                      maxHeight: ITEM_HEIGHT * 4.5,
                      width: '12ch',
                    },
                  }}}
                >
                  {/* <MenuItem onClick={() => handleactivatedeactivate(row.id, row.isActive, row.clientName)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 19 19" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M9.5 0C4.26134 0 6.78571e-07 4.26134 0 9.5C6.78571e-07 14.7387 4.26134 19 9.5 19C14.7387 19 19 14.7387 19 9.5C19 4.26134 14.7387 0 9.5 0ZM9.5 1.35714C14.0052 1.35714 17.6429 4.99479 17.6429 9.5C17.6429 14.0052 14.0052 17.6429 9.5 17.6429C4.99479 17.6429 1.35714 14.0052 1.35714 9.5C1.35714 4.99479 4.99479 1.35714 9.5 1.35714Z" fill="#77869E" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M2.78219 2.78334C2.65497 2.9106 2.5835 3.08317 2.5835 3.26311C2.5835 3.44306 2.65497 3.61563 2.78219 3.74289L15.2576 16.2183C15.3206 16.2815 15.3955 16.3316 15.4779 16.3658C15.5604 16.4 15.6487 16.4176 15.738 16.4176C15.8273 16.4176 15.9156 16.4 15.9981 16.3658C16.0805 16.3316 16.1554 16.2815 16.2184 16.2183C16.3457 16.091 16.4171 15.9184 16.4171 15.7385C16.4171 15.5585 16.3457 15.386 16.2184 15.2587L3.74306 2.78334C3.68003 2.72015 3.60514 2.67001 3.5227 2.6358C3.44026 2.60159 3.35188 2.58398 3.26263 2.58398C3.17337 2.58398 3.08499 2.60159 3.00255 2.6358C2.92011 2.67001 2.84523 2.72015 2.78219 2.78334Z" fill="#77869E" />
                  </svg> <span style={{ paddingLeft: '15px' }} className='text-muted font-normal'>{row.isActive ? "Deactivate" : "Activate"}</span>
                </MenuItem> */}
                  <BootstrapTooltip title={row.isGroupInUse === true ? GROUP_DELETE_INVALID : ""} arrow disableHoverListener={row.isGroupInUse !== true}>
                    <span>
                      <MenuItem onClick={() => handleDeleteGroup(row.id, row.groupName)} disabled={row.isGroupInUse === true}>
                        <span style={{ cursor: row.isGroupInUse !== true ? 'pointer' : 'not-allowed', color: row.isGroupInUse === true ? '#A0A0A0' : '#F13139' }}>Delete</span>
                      </MenuItem>
                    </span>
                  </BootstrapTooltip>
                </Menu>
              </div>
            }
          </div>
        )
      },
      width: '10%',
      sortable: false,
      center: true,
    },

  ]

  return (
    <>
      <h2 className="text-2xl font-semibold text-title">Manage Groups</h2>
      <div className="mt-[20px] mb-[20px] live-outreach-container">
      <Grid container spacing={2} alignItems={'center'}>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <div className="w-full">
            <input
              type="text"
              placeholder="Search by group"
              className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full"
              onChange={handleSearch}
            />
          </div>
        </Grid>
        <Grid item xs={6} md={6} lg={8} className='bulk-action flex justify-end'>
          {checkEventPermission("GROUPS_ADD") &&
            <GradientButton color='red' onClick={handleAddGroupClick}>
              <span style={{
                width: "20px",
                height: "20px",
                background: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50px",
                marginRight: "5px"
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                  <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                  <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
                </svg>
              </span>
              Add New Group
            </GradientButton>
          }
        </Grid>
      </Grid>
      </div>
      {/* <div className="flex my-5 gap-x-2 justify-between items-center">
        <div className="basis-3/5">
          <div className="form-control">
            <input type="text" placeholder="Search by group" className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full" onChange={handleSearch} />
          </div>
        </div>
        <div className="basis-2/5 justify-end flex">
          {checkEventPermission("GROUPS_ADD") &&
            <GradientButton color='red' onClick={handleAddGroupClick}>
              <span style={{
                width: "20px",
                height: "20px",
                background: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50px",
                marginRight: "5px"
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                  <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                  <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
                </svg>
              </span>
              Add New Group
            </GradientButton>
          }
        </div>
      </div> */}
      <div className='data-table-container mb-10 te-table-container'>
        <CustomDataTable
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          columns={columns}
          data={groupSearchData}
          pagination
          // selectableRows
          progressPending={loading}
        />

        <MUIModal title='New Group' openModal={openAddGroupModal} closeModal={handleCloseAddGroupModal} width={'50%'} >
          <AddGroupForm closeModal={handleCloseAddGroupModal} refreshPage={handleRefreshPage} />
        </MUIModal>
        <MUIModal title='Edit Group' openModal={openEditGroupModal} closeModal={handleCloseEditGroupModal} width={'50%'} >
          <EditGroupForm closeModal={handleCloseEditGroupModal} refreshPage={handleRefreshPage} id={groupId} />
        </MUIModal>

        <BootstrapDialog
          onClose={handleDeleteGroupClose}
          aria-labelledby="customized-dialog-title"
          open={showDeleteGroupModal}
          PaperProps={{
            sx: {
              width: '550px',
              height: '200px'
            },
          }}
        >
          <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
            Delete Group
          </DialogTitle>

          <IconButton
            aria-label="close"
            onClick={handleDeleteGroupClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <HugeiconsIcon
              icon={MultiplicationSignStrokeStandard}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
            />
          </IconButton>
          <DialogContent>
            <p className='text-14 text-muted'>{ARE_YOU_SURE} {DELETE_GROUP} <span className='font-semibold'>{groupInfoData?.groupName}</span>?</p>
          </DialogContent>
          <DialogActions sx={{ background: '#F9F9F9' }}>

            <OutlineButton color='gray' onClick={handleDeleteGroupClose} width='100px'>Cancel</OutlineButton>

            <GradientButton type='button' color='red' onClick={handleDeleteGroupConfirm} width='100px'>{!isModalSaveLoading ? 'Delete' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
          </DialogActions>
        </BootstrapDialog>

        {/* <BootstrapDialog
        onClose={handleactivatedeactivateClose}
        aria-labelledby="customized-dialog-title"
        open={showDeactivateWebhookModal}
        PaperProps={{
          sx: {
            width: '550px',
            height: '200px'
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
          {(Boolean((groupInfoData?.isActive))) ? "Activate" : "Deactivate"}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleactivatedeactivateClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <p className='text-14 text-muted'>{ARE_YOU_SURE} {(Boolean((groupInfoData?.isActive))) ? "activate the webhook" : "deactivate the webhook"} <span className='font-semibold'>{groupInfoData?.clientName}</span>?</p>
        </DialogContent>
        <DialogActions sx={{ background: '#F9F9F9' }}>

          <OutlineButton color='gray' onClick={handleactivatedeactivateClose} width='130px'>Cancel</OutlineButton>

          <GradientButton type='button' color='red' onClick={handleActivateDeactivateConfirm} width='130px'>{!isModalSaveLoading ? "OK" : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
        </DialogActions>
      </BootstrapDialog> */}

      </div>
    </>
  );
};


export default GroupList;
